import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=a70b0d22&scoped=true&"
import script from "./LoadingDialog.vue?vue&type=script&lang=js&"
export * from "./LoadingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b0d22",
  null
  
)

export default component.exports